import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-50888dd6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "companion-player-space"
}
const _hoisted_2 = {
  key: 0,
  class: "spot spot--show-teammate"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spot-echo" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spot-inner" }, null, -1))
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "spot"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spot-inner" }, null, -1))

import { computed } from 'vue';

import { useGameState } from '@/services/composition';
import { playerScreenPosition } from '@/services/states/GameContextDatas'
import gsap from 'gsap';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const state = useGameState()

const playerTransform = computed(() => {
  const pos = playerScreenPosition(state.value.context.position)
  return { top: `calc(${pos[1] * 100}% - 2rem * 0.5)`, left: `calc(${pos[0] * 100}% + 2rem * 0.5)` }
})

const playerRotate = computed(() => {
  const rotation = state.value.context.rotation
  // console.log(`rotate(${rotation - Math.PI}rad)`)
  return { transform: `rotate(${rotation - Math.PI}rad)` }
})

const onEnterSpot = (el: Element, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.fromTo(el, { scale: 0 }, { scale: 1, duration: 1, ease: 'quint.out' })
  if (state.value.matches('tuto.companion.teammate')) {
    tl.fromTo($('.spot-echo'), { scale: 0 }, { scale: 1, duration: 1, ease: 'quint.out' }, 0.2)
  } else {
    tl.fromTo($('.spot-fov'), { scaleY: 0 }, { scaleY: 1, duration: 1, ease: 'quint.out' }, 0.2)
  }
}

const onLeaveSpot = (el: Element, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { scale: 0, duration: 1, ease: 'quint.in' })
  if (state.value.matches('tuto.companion.teammate')) {
    tl.to($('.spot-echo'), { scale: 0, duration: 1, ease: 'quint.in' }, 0)
  } else {
    tl.to($('.spot-fov'), { scaleY: 0, duration: 1, ease: 'quint.out' }, 0)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (!_unref(state).matches('intro'))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
              class: "companion-player",
              style: _normalizeStyle(_unref(playerTransform))
            }, [
              _createVNode(_Transition, {
                css: false,
                mode: "out-in",
                appear: "",
                onEnter: onEnterSpot,
                onLeave: onLeaveSpot
              }, {
                default: _withCtx(() => [
                  (_unref(state).matches('tuto.companion.teammate'))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_5))
                    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", {
                          class: "spot-fov",
                          style: _normalizeStyle(_unref(playerRotate))
                        }, null, 4),
                        _hoisted_7
                      ]))
                ]),
                _: 1
              })
            ], 4)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})